import React from 'react'
import { useLocation } from 'react-router-dom';

function NavBar() {

    const location = useLocation();
    const isTandCPage = location.pathname === '/TermsConditions';
    const isPandPPage = location.pathname === '/privacy';

  return (
    <div className="sticky-navbar">
       <nav className="navbar navbar-expand-lg shadow-lg">
            <div className="container">
                <a className="navbar-brand" href="https://www.foneapp.asia">
                <img src="images/icons/FONEAPP LOGO.png" className="imagesize" alt="FoneApp Community"/>
                </a>

                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav ms-auto">
                    
                        <li className="nav-item">
                            <a className="nav-link click-scroll" href={isTandCPage || isPandPPage ? "/#AboutUs" : "#AboutUs"}>About Us</a>
                        </li>

                        <li className="nav-item">
                            <a className="nav-link click-scroll"  href={isTandCPage || isPandPPage ? "/#section_M20" : "#section_M20"}>M2O Loyalty Program</a>
                        </li>

                        <li className="nav-item">
                            <a className="nav-link click-scroll"  href={isTandCPage || isPandPPage ? "/#section_Partner" : "#section_Partner"}>Be Our Partner</a>
                        </li>

                        <li className="nav-item">
                            <a className="nav-link click-scroll"  href={isTandCPage || isPandPPage ? "/#section_FonePlus" : "#section_FonePlus"}>FonePlus</a>
                        </li>

                        <li className="nav-item">
                            <a className="nav-link click-scroll"  href={isTandCPage || isPandPPage ? "/#section_Team" : "#section_Team"}>Our Team</a>
                        </li>

                        <li className="nav-item">
                            <a className="nav-link click-scroll" href={isTandCPage || isPandPPage ? "/#section_ContactUs" : "#section_ContactUs"}>Contact Us</a>
                        </li>

                    </ul>
                </div>
            </div>
        </nav>

        <div className="site-header1">
        </div>

    </div>
  )
}

export default NavBar
